module.exports = __webpack_public_path__ + "img/zc-03.102f14a3.svg";